import { Campaign, Maybe } from '../generated/contentful-generated-types';
import { isCampaignForCurrentCountry } from '../utils/campaign';
import { showForUserMultiple } from '../utils/contentful';
import { useIsRegisteredNonBuyer, useIsLoggedIn, useIsReseller } from './useLogin';

export function useCampaign(campaigns: Campaign[] | Maybe<Campaign>[] | undefined) {
  if (campaigns == undefined) return;

  // Sort by biggest discountPercentage
  const sorted = selectAndSortApplicableCampaign(campaigns);
  return sorted?.[0];
}

export function selectAndSortApplicableCampaign(campaigns: Campaign[] | Maybe<Campaign>[] | undefined | null) {
  if (campaigns == undefined) return;

  const isLoggedIn = useIsLoggedIn();
  const isRegisteredNonBuyer = useIsRegisteredNonBuyer();
  const isReseller = useIsReseller();

  const eligibleCampaigns = campaigns.filter(
    campaign =>
      campaign != null &&
      isCampaignForCurrentCountry(campaign) &&
      showForUserMultiple(campaign.showOnlyForMultiple, isReseller, isLoggedIn, isRegisteredNonBuyer)
  ) as Campaign[];

  // Sort by biggest discountPercentage
  const sorted = eligibleCampaigns.sort((c1, c2) => Number(c2.discountPercentage) - Number(c1.discountPercentage));

  return sorted;
}
